package com.sweetlime.bingeamigo.model

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class XpLogEntry(
    val action: String = "",
    val entityId: String = "",
    val xp: Int = 0,
    val timestamp: Timestamp? = null
)